export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-600-normal.woff2?4c20c4dd1324db23e1c2cc630fa6be6b";